import { Hash, StatStructure, BasicStatStructure, CategoricalStatStructure, ComplexStatStructure } from '../../common/types'
import { Key } from '../constants'
import pb from '../pubsub';
import { requestStats } from '../storage/predict'
import { metricIcons as icons } from '../../common/constants'
const utils = require("../utils");
const pubsub = pb.setup('controls')

/*::
import FuzzySet from 'javascriptLibs'
 */

let mapContainer = document.getElementById('map-container')
let selectionContainer = document.getElementById('selected_stats')
let availableContainer = document.getElementById('available_stats_container')
let selectedChipsContainer = document.getElementById('selected_chips')
let yearField = document.getElementById('year_selected')
let header = document.getElementsByTagName('header')[0]

let expandArea = document.getElementById('side_menu_expansion')
let expandMenu = document.getElementById('side_menu_1')
let expandMenu2 = document.getElementById('side_menu_2')
let expandMenu3 = document.getElementById('side_menu_3')
let expansions = [ availableContainer, expandMenu, expandMenu2, expandMenu3 ]
// let fuzzySearch = FuzzySet()

let categoryDisclaimer = document.getElementById('category_disclaimer')

let expandedTag = 'expanded_complex_control'
let selectedMetric = 'selected_metric'


// let icons = {
//     'income': 'attach_money',
//     'population': 'family_restroom',
//     'migration': 'language',
//     'employment': 'card_travel',
//     'housing': 'home',
//     'sales': 'home',
//     'business': 'business',
//     'transportation': 'commute',
//     'education': 'school',
//     'government': 'account_balance',
//     'taxes': 'percent',
//     'crime': 'local_police',
//     'climate': 'water_drop',
// }

// colors the chip based on score/weight
let voteMap = [
    'rgb(167,66,52)',
    'rgb(177,66,52)',
    'rgb(187,66,52)',
    'rgb(197,66,52)',
    'rgb(207,66,52)',
    'rgb(217,66,52)',
    'rgb(227,66,52)',
    'rgb(200,200,200)',
    'rgb(76,175,80)',
    'rgb(76,165,80)',
    'rgb(76,155,80)',
    'rgb(76,145,80)',
    'rgb(76,135,80)',
    'rgb(76,125,80)',
    'rgb(76,115,80)',
]

// expand/shrink controls
let controlContentList = [...document.getElementsByClassName('content')];
let controlExpandIconList = [...document.getElementsByClassName('expand-icon')];

const features = ((document.getElementById('individual-features'): any): HTMLElement);
const mapControls = ((document.getElementById('leaflet-controls'): any): HTMLElement);
let expandedControl = features;
([
    features,
    mapControls
]).forEach(control => {
    let expandBtn = control.getElementsByClassName('expand-btn')[0];
    let expandIcon = control.getElementsByClassName('expand-icon')[0];
    let content = control.getElementsByClassName('content')[0];
    expandBtn.onclick = () => {
        let expanded = expandIcon.innerHTML === 'expand_less';
        controlContentList.forEach(el => el.style.display = "");
        controlExpandIconList.forEach(el => el.innerHTML = "expand_more");
        if (!expanded) {
            content.style.display = "block";
            expandIcon.innerHTML = "expand_less";
        }
        document.getElementById('side_menu_expansion').style.display = ''
        expandedControl = control
    };
    
    // start with individual features expanded
    if (control === features) {
        expandBtn.click();
    }
});
pubsub.subscribe(['location:load', 'zoom:reset'], () => {
    // when location changes, make sure region control is opened for convenience
    if (expandedControl !== mapControls) {
        mapControls.getElementsByClassName('expand-btn')[0].click()
    }
})

let computeButton = ((document.getElementById('compute-stats-btn'): any): HTMLInputElement);

// a multi-word search
function findMatch(list: ControlBase[], query: string): ControlBase[] {
    if (!query.includes(' ')) {
        // simple search with no spaces
        return list.filter(s => query && s.name.toLowerCase().includes(query.toLowerCase()) && !s.isComplex)
    } else {
        // multiple keywords to search
        let keywords = query.split(' ')
        return list.filter(s => !s.isComplex && keywords.every(k => k && s.name.toLowerCase().includes(k.toLowerCase())))
    }
}

export class Controls {

    selectedYear: Number;
    selectedFocus: string;
    selectedStats: Hash;
    selectedCategory: ?string;
    selectedCategoryFilter: ?number[];

    selectedFilters: { [string]: { // the key is the stat name
        filter: {
            min?: number,
            max?: number,
            threshold?: number,
        },
        filterOnly: boolean
    }};
    delta: { [string]: number }; // the key is the chip id, can't use stat name due to potential name clash

    _stats: { [string]: StatStructure };
    _menuOpen: boolean;
    controls: BasicControl[];
    complexMap: { [string]: ComplexControl };

    constructor(query: Hash) {
        this.setYear(query.year)

        this._menuOpen = false
        this.search = this.search.bind(this)
        this.selectedFilters = {}
        this.delta = {}

        if (query.focus) {
            this.selectedFocus = query.focus
        }
        // pre-selected metrics, if any
        this.selectedStats = {}
        Object.keys(query).filter(k => !['year', 'focus', 'granularity'].includes(k)).forEach(key => {
            this.selectedStats[key] = query[key]
        })
        this.selectedFilters = {}

        this.complexMap = {}

        // fetch/render stats
        requestStats().then(stats => {

            this._stats = stats
            let template = {}
            this.controls = Object.keys(stats).filter(statName => stats[statName].type !== 'basic').map(statName => {
                let stat = stats[statName]
                if (stat.type === 'complex') {
                    template[statName] = {
                        title: utils.prettyName(statName),
                        prefix: statName,
                        //element: (s) => `<i class="mdl-icon-toggle__label material-icons">${s.icon}</i><span class="query">${s.label}</span>`,
                        element: (s) => {
                            return {
                                query: s.label,
                                icon: statName,
                                unit: s.data.unit
                            }
                        },
                        fetchFn: (query: string): Promise<ControlBase[]> => {
                            // filter queries whose name is superset of user-typed query AND not sub-stats
                            return Promise.resolve(findMatch(this.complexMap[statName].children, query))
                        },
                        onClick: (s) => {
                            s.onClick()
                        },
                        onHover: (s) => {
                            s.onHover()
                        }
                    }

                    // unwrap children that are also complex
                    Object.entries(stats[statName].children).forEach(([name, obj]) => {
                        if (obj.type === 'complex') {
                            stats[name] = obj
                            template[name] = {
                                title: utils.prettyName(name),
                                prefix: name,
                                //element: (s) => `<i class="mdl-icon-toggle__label material-icons">${s.icon}</i><span class="query">${s.label}</span>`,
                                element: (s) => {
                                    return {
                                        query: s.label,
                                        icon: name,
                                        unit: s.data.unit
                                    }
                                },
                                fetchFn: (query: string) => {
                                    return Promise.resolve(findMatch(this.complexMap[name].children, query))
                                },
                                onClick: (s) => {
                                    s.onClick()
                                },
                                onHover: (s, e) => {
                                    s.onHover(e)
                                }
                            }
                        }
                    })

                    this.complexMap[statName] = new ComplexControl(statName, stat, this, icons[statName], 0)
                    return this.complexMap[statName] 
                } else if (stat.type.slice(0, 11) === 'categorical') {
                    return new CategoryControl(statName, stat, this, 0)
                }
                return new BasicControl(statName, stat, this, 0)
            })
            this.render()

            // render selected stats (these are pulled from the URL)
            if (Object.keys(this.selectedStats).length) {
                let isCategory = false
                Object.keys(this.selectedStats).forEach(k => {
                    if (k === 'focus') {
                        // not a real category, skip
                        return;
                    }
                    let isFilter = k.slice(0, 7) === 'filter:'
                    let baseName = isFilter ? k.slice(7) : k
                    let noFilterName = baseName
                    let delta = 0
                    if (k.includes(':delta:')) {
                        [baseName, delta] = k.split(':delta:')
                        delta = parseInt(delta)
                    }

                    if (!isCategory) { // used to skip other stats if category is selected
                        let data = this.getStat(baseName)
                        isCategory = data.type.slice(0, 11) === 'categorical'
                        let value = parseInt(query[k])
                        console.log('value', value, query)
                        if (isCategory && query[k].includes(',')) {
                            this.selectedCategory = k
                            value = this.selectedCategoryFilter = query[k].split(',').map(i => parseInt(i))
                        } else if (isFilter) {
                            // filter
                            let noFilterName = k.slice(7)
                            value = parseInt(query[noFilterName]) || 1 // don't use value from filter
                            let filters = {}
                            query[k].split(',').forEach(filter => {
                                let [key, val] = filter.split(':')
                                filters[key] = parseFloat(val)
                            })
                            this.selectedFilters[baseName] = {
                                filter: filters,
                                filterOnly: !(noFilterName in this.selectedStats) || parseInt(this.selectedStats[noFilterName]) === 0
                            }
                        }
                        if (!query[`filter:${k}`]) { // otherwise the filter will render it
                            this.renderChip(null, k, data.info, isCategory, value)
                        }
                    }
                })
            }

            // render summary of selected stats
            let timelineStats = ((document.getElementById('timeline-stats'): any): HTMLInputElement);
            timelineStats.innerText = this.humanFriendlyStats()

            // now setup search box
            pubsub.publish('setup:searchbox', {
                searchParams: {
                    searchFn: this.search,
                    type: 'metricSearch',
                    serverSearch: false
                },
                template: template
            })

            pubsub.subscribe('categoryFilter:apply', (filter: number[] | null) => {
                this.selectedCategoryFilter = filter
                computeButton.disabled = false
                computeButton.click()
            })
            pubsub.subscribe('metricFilter:apply', (data: {selectedMetric: ControlBase, delta: number, filters: { [string]: number}, filtersOnly: boolean}) => {
                if (Object.keys(data.filters).length) {
                    this.selectedStats[`filter:${data.selectedMetric.name}`] = Object.keys(data.filters).map(k => `${k}:${data.filters[k]}`).join(',')
                }
                this.delta[data.selectedChip.id] = data.delta
                this.selectedFilters[data.selectedMetric.name] = {
                    filter: data.filters,
                    filterOnly: data.filterOnly
                }
                computeButton.disabled = false
                computeButton.click()
            })
            pubsub.subscribe('metricFilter:reset', (data: {selectedMetric: ControlBase}) => {
                delete this.selectedStats[`filter:${data.selectedMetric.name}`]
                delete this.selectedFilters[data.selectedMetric.name]
                delete this.delta[data.selectedChip.id]
                computeButton.disabled = false
                computeButton.click()
            })

            computeButton.disabled = true
        })

        pubsub.establish('dialog:metrics')
        pubsub.subscribe('dialog:render', (d) => {
            if (d.type === 'analyticsPanel') {
                let selectedMetrics = Object.keys(this.selectedStats).map(k => {
                    let id = `chip-${k.replace(/:/g, '--')}`
                    let baseName = k.includes(':delta:') ? k.split(':delta:')[0] : k
                    let control = this.getStatControl(baseName)
                    return { id, control }
                })
                pubsub.publish('dialog:metrics', { selectedMetrics })
            }
        })

        // hide secondary menus on click outside
        let ctx = this
        window.addEventListener('click', function (e) {
            if (
                !availableContainer.contains(e.target) &&
                !expandMenu.contains(e.target) &&
                !expandMenu2.contains(e.target) &&
                !expandMenu3.contains(e.target)
            ){
                ctx._menuOpen = false
                expandMenu.style.display = ''
                expandMenu2.style.display = ''
                expandMenu3.style.display = ''
                Array.from(document.getElementsByClassName(selectedMetric)).forEach(e => e.classList.remove(selectedMetric))
                Array.from(document.getElementsByClassName(expandedTag)).forEach(e => e.classList.remove(expandedTag))
            }
        })

        // hide selection on hover outside menu when no stats are open
        availableContainer.addEventListener('mouseleave', function (e) {
            if (!ctx._menuOpen) {
                Array.from(document.getElementsByClassName(selectedMetric)).forEach(e => e.classList.remove(selectedMetric))
            }
        })
    }

    init () {
        utils.setMdlVal(yearField, this.selectedYear)
        yearField.addEventListener('blur', () => this.setYear(yearField.value))
        yearField.addEventListener('keydown', (key) => {
            computeButton.disabled = false
            if (key.keyCode === Key.ENTER) {
                this.setYear(yearField.value)
            }
        })

        this.controls.forEach(s => s.init())
    }

    // normalizes nested stats into regular representation (cuts off outermost group)
    _normalizeStat(statName: string) {
        let [one, two, three] = statName.split(':')
        if (three) {
            return [two, three]
        }
        return [one, two]
    }

    // get API-like stat representation
    getStat(statName: string) {
        let [stat, substat] = this._normalizeStat(statName)
        let obj = substat ? this._stats[stat].children[substat] : this._stats[stat]
        return obj
    }

    // get control object that wraps the stat
    getStatControl(statName: string) {
        let [stat, substat] = this._normalizeStat(statName)
        let topLevelControl = this.complexMap[stat]
        let obj = substat ? topLevelControl.children.find(c => c.name === statName) : topLevelControl
        return obj
    }

    // get a list of stats user requested in human-friendly format
    humanFriendlyStats() {
        if (this.selectedCategory) {
            // selected a category
            let full = this.getStatControl(this.selectedCategory).data.info
            let brief = full.split('.')[0]
            brief = brief.split(' (categories')[0]
            return brief
        } else {
            // regular ranks selected
            let sameWeights = true
            let first
            Object.values(this.selectedStats).forEach(w => {
                if (!first) {
                    first = w
                } else if (w !== first) {
                    sameWeights = false
                }
            })
            let list = []
            Object.keys(this.selectedStats).forEach(statName => {
                if (statName.slice(0, 7) === 'filter:') {
                    // for now skip filters, eventually we want to include them in description too
                    return
                }
                let delta = null
                if (statName.includes(':delta:')) {
                    let parts = statName.split(':delta:')
                    statName = parts[0]
                    delta = parts[1]
                }
                let stat = this.getStatControl(statName)
                let name = delta? stat.humanFriendlyDeltaName : stat.humanFriendlyName

                if (!sameWeights) {
                    name += ` (${this.selectedStats[statName]})`
                }
                list.push(name)
            })
            if (list.length > 1) {
                list[list.length - 1] = 'and ' + list[list.length - 1]
            }
            return list.join(list.length > 2 ? ', ': ' ')
        }
    }

    search (stat) {
        if (stat.name && this.validateChip(stat.name)) {
            this.renderChip(
                null,
                stat.name,
                this._stats[stat.name].data.info,
                this._stats[stat.name].data.type.slice(0, 11) === 'categorical',
                this._stats[stat.name].data.negate ? -1 : 1
            )
        }
    }

    setYear(year: string | number) {
        computeButton.disabled = false
        year = parseInt(year)
        if (year && 1990 < year && year < 2050) {
            this.selectedYear = year
        } else {
            this.selectedYear = new Date().getFullYear()
        }
        yearField.value = this.selectedYear
    }

    getSelectedStats() {
        if (this.selectedCategory) {
            return { [this.selectedCategory]: this.selectedCategoryFilter || 1 }
        }
        const metrics = { ...this.selectedStats }
        Object.keys(metrics).forEach(k => {
            if (k.slice(0, 7) === 'filter:') {
                const base = k.slice(7)
                const filter = this.selectedFilters[base].filter
                metrics[k] = Object.keys(filter).map(k => `${k}:${filter[k]}`).join(',')
            }
        })
        return metrics
    }

    renderChip(icon: string, name: string, info: string, category: boolean = false, score: number = 1) {
        let metricName = name.slice(0, 7) === 'filter:' ? name.slice(7) : name
        let noFilterName = metricName
        let delta = 0
        if (metricName.includes(':delta:')) {
            const parts = metricName.split(':delta:')
            metricName = parts[0]
            delta = parseInt(parts[1])
        }
        let [stat, substat] = this._normalizeStat(metricName)
        let id = `chip-${name.replace(/:/g, '--')}`
        let element = document.getElementById(id)
        computeButton.disabled = false

        console.log('rendering chip', name, element, this.selectedStats)
        if (this.selectedStats[name] && element) {
            // if chip already exists, simply upvote it (if negative, will become 1)
            if (!category) {
                this.selectedStats[name] = Math.max(0, this.selectedStats[name]) + 1
                document.getElementById(`vote-${id}`).innerText = this.selectedStats[name]
                document.getElementById(id).style.background = voteMap[Math.min(this.selectedStats[name] + 7, voteMap.length)]
            }
            return
        } else if (element) {
            // element with this id exists but is not in selectedStats, it was probably changed to delta
            // need to pick a different id to avoid collision
            id += Math.random().toString(36).substring(2, 15)
            element = document.getElementById(id)
        }

        this.delta[id] = delta
        
        if (category) {
            // category chips override all other chips
            this.selectedCategory = name
            Array.from(document.getElementsByClassName('selected_chip')).forEach(e => e.style.display = 'none')
            availableContainer.style.display = 'none'
            categoryDisclaimer.style.display = 'block'
        } else {
            // regular (non-category) chip
            this.selectedStats[name] = score
        }

        let weight = parseInt(this.selectedStats[noFilterName]) || 0
        let weightTag = category ? '' :`
        <span id="weight-${id}" class="mdl-chip__contact mdl-color-text--white chip_vote">
            <span id="downvote-${id}" class="downvote">&lt;</span>
            <span id="vote-${id}">${weight}</span>
            <span id="upvote-${id}" class="upvote">&gt;</span>
        </span>`

        // render the chip
        selectedChipsContainer.insertAdjacentHTML('beforeend', `
        <span id="${id}" class="mdl-chip mdl-chip--deletable selected_chip${category ? ' category_chip' : ''}">
            ${weightTag}
            <i id="${id}-icon" class="material-icons mdl-list__item-icon chip-icon">${icons[stat]}</i>
            <span class="mdl-chip__text chip_name">
                ${utils.prettyName(substat)}
                <span id="delta-${id}" class="delta">${delta ? 'Δ' + delta : ''}</span>
                <button type="button" class="mdl-chip__action chip_edit ${category && this.selectedCategoryFilter ? 'dirty-filter' : ''}" id="edit-${id}"><i class="material-icons">filter_list</i></button>
            </span>
            <button type="button" class="mdl-chip__action" id="del-${id}"><i class="material-icons">cancel</i></button>
        </span>
        `)
        if (!element) {
            element = document.getElementById(id)
        }

        // give the tooltip to the icon
        let iconElement = document.getElementById(`${id}-icon`)
        iconElement.addEventListener('mouseover', (e) => {
            e.stopPropagation()
            pubsub.publish('tooltip:show', {
                element: iconElement,
                message: `Topic: ${this.complexMap[stat].humanFriendlyName}`
            })
        })

        // give the chip a tooltip
        if (info) {
            const chip = document.getElementById(id)
            chip.addEventListener('mouseover', () => {
                pubsub.publish('tooltip:show', {
                    element: chip,
                    message: `${info} (${this.selectedYear}).`
                })
            })
        }

        // and an edit button
        const chipEdit = document.getElementById(`edit-${id}`)
        chipEdit.addEventListener('mouseover', (e) => {
            e.stopPropagation()
            const isDirty = chipEdit.classList.contains('dirty-filter')
            pubsub.publish('tooltip:show', {
                element: chipEdit,
                message: category ?
                    (isDirty ? `Hide/show certain categories (${this.selectedCategoryFilter.length} selected).` :
                               'Hide certain categories.') :
                    (isDirty ? `Edit the filter (current: ${JSON.stringify(this.selectedFilters[metricName].filter)})` :
                               'Edit metric type or create a filter based on it.')
            })
        })
        // toggle this edit/filter button default visibility based on whether the filter is dirty
        if (name.slice(0,7) === 'filter:') {
            chipEdit.classList.add('dirty-filter')
        }
        pubsub.subscribe('categoryFilter:apply', (filter) => {
            if (filter) {
                chipEdit.classList.add('dirty-filter')
            } else {
                chipEdit.classList.remove('dirty-filter')
            }
        })
        const chipDelta = document.getElementById(`delta-${id}`)
        const voteEl = document.getElementById(`vote-${id}`)
        pubsub.subscribe('metricFilter:apply', (data) => {
            if (data.selectedChip.id === id) { // make sure we're processing the right chip, since all metrics subscribe to this
                if (data.filterOnly) {
                    voteEl.innerText = 0
                    element.style.background = voteMap[7]
                    this.selectedStats[name] = 0
                }
                const oldDelta = parseInt(chipDelta.innerText.slice(1))
                if (data.delta || oldDelta) {
                    const newName = data.delta ? `${data.selectedMetric.name}:delta:${data.delta}` : `${data.selectedMetric.name}`
                    const oldName = oldDelta ? `${data.selectedMetric.name}:delta:${oldDelta}` : `${data.selectedMetric.name}`
                    chipDelta.innerText = data.delta ? `Δ${data.delta}` : ''
                    this.selectedStats[newName] = this.selectedStats[oldName]
                    delete this.selectedStats[oldName]
                } else {
                    chipEdit.classList.add('dirty-filter')
                }
            }
        })
        pubsub.subscribe('metricFilter:reset', (data) => {
            if (data.selectedChip.id === id) {
                const oldDelta = parseInt(chipDelta.innerText.slice(1))
                console.log('oldDelta', oldDelta)
                if (oldDelta) {
                    const newName = data.selectedMetric.name
                    const oldName = oldDelta ? `${data.selectedMetric.name}:delta:${oldDelta}` : `${data.selectedMetric.name}`
                    this.selectedStats[newName] = this.selectedStats[oldName]
                    delete this.selectedStats[oldName]
                }
                chipDelta.innerText = ''
                chipEdit.classList.remove('dirty-filter')
            }
        })

        document.getElementById(`edit-${id}`).addEventListener('click', () => {
            if (category) {
                // use category select-box panel to hide/show categories
                pubsub.publish('dialog:render', {
                    type: 'categoryFilter',
                    params: {
                        control: this.getStatControl(name),
                        chip: id,
                        selection: this.selectedCategoryFilter
                    }
                })
            } else {
                // use a math-based filter
                const filter = this.selectedFilters[metricName]
                const modifier = {
                    delta: this.delta[id] || 0,
                    filter: { none: 100 },
                    filterOnly: false
                }
                if (filter) {
                    modifier.filter = filter.filter
                    modifier.filterOnly = filter.filterOnly
                }
                pubsub.publish('dialog:render', {
                    type: 'basicFilter',
                    params: {
                        control: this.getStatControl(metricName),
                        chip: id,
                        modifier: modifier
                    }
                })
            }
        })

        // and a delete button
        document.getElementById(`del-${id}`).addEventListener('click', () => {
            if (this.selectedCategory) {
                delete this.selectedCategory
                delete this.selectedCategoryFilter
                delete this.selectedFilters[metricName]
                delete this.delta[id]
                Array.from(document.getElementsByClassName('selected_chip')).forEach(e => e.style.display = '')
                availableContainer.style.display = ''
                categoryDisclaimer.style.display = ''
            }
            this.deleteChip(name, id)
        })

        // and vote buttons if not category
        if (!category) {
            // set the initial color
            element.style.background = voteMap[Math.max(weight + 7, 0)]

            let downvote = document.getElementById(`downvote-${id}`)
            let upvote = document.getElementById(`upvote-${id}`)
            downvote.addEventListener('click', () => {
                computeButton.disabled = false
                if (this.selectedStats[name] === 1) {
                    this.selectedStats[name] = -1
                } else {
                    this.selectedStats[name]--
                }
                document.getElementById(`vote-${id}`).innerText = this.selectedStats[name] // update weight
                element.style.background = voteMap[Math.max(this.selectedStats[name] + 7, 0)]
            })
            upvote.addEventListener('click', () => {
                computeButton.disabled = false
                if (this.selectedStats[name] === -1) {
                    this.selectedStats[name] = 1
                    element.style.background = ''
                } else {
                    this.selectedStats[name]++
                }
                document.getElementById(`vote-${id}`).innerText = this.selectedStats[name] // update weight
                element.style.background = voteMap[Math.min(this.selectedStats[name] + 7, voteMap.length)]
            })

            // also add tooltips
            let scoreTag = document.getElementById(`weight-${id}`)
            scoreTag.addEventListener('mouseover', (e) => {
                e.stopPropagation()
                pubsub.publish('tooltip:show', {
                    element: scoreTag,
                    message: `Weight relative to other metrics. Higher weight increases metric importance (ranking by highest ${name} per zipcode), negative weight aims to find the lowest ${name} per zipcode instead.`
                })
            })
        }

        // now that we have at least one chip selected, we can unhide selection container
        selectionContainer.style.display = "block";
    }

    // verify if operation is valid
    validateChip(name: string) {
        let [stat, substat] = this._normalizeStat(name)
        if (this._stats[stat] && (!substat || (this._stats[stat].children && this._stats[stat].children[substat]))) {
            // good to create
            return true
        } else {
            pubsub.publish('notify:error', `"${name}" is not a valid metric.`)
            return false
        }
    }

    deleteChip(name: string, id: string) {
        computeButton.disabled = false
        delete this.selectedStats[name]
        delete this.selectedStats[`filter:${name}`]

        document.getElementById(id).remove()
        if (!Object.keys(this.selectedStats).length) {
            selectionContainer.style.display = ''
        }
    }

    render () {
        let container = document.querySelector('#available_stats')
        container.innerHTML = `
        <style>
            #selected_chips .chip-icon {
                color: white;
                line-height: 0;
                vertical-align: middle;
                display: inline;
                margin-right: 2px;
                margin-left: -10px;
            }
            #selected_chips .chip_edit {
                display: none;
            }
            #selected_chips .chip_edit.dirty-filter {
                display: inline-block;
            }
            #selected_chips .chip_name:hover .chip_edit {
                display: inline-block;
            }
            #selected_chips .mdl-chip {
                background: rgb(76,175,80);
                color: white;
                display: table;
            }
            #selected_chips > .category_chip.mdl-chip {
                background: #0074D9;
            }
            #selected_chips > .category_chip.mdl-chip > .chip-icon {
                padding-left: 5px;
            }
            .available_metrics_list {
                padding: 0px;
            }
            .expand_stats,
            .selectable_stat {
                cursor: pointer;
            }
            .${expandedTag},
            .${selectedMetric} {
                background: rgb(76,175,80);
            }
            .chip_vote {
                font-family: 'Poppins', sans-serif;
                cursor: default;
                margin-left: -10px;
                user-select: none;
            }
            .chip_vote span:first-child,
            .chip_vote span:last-child {
                display: none;
            }
            .chip_vote:hover {
                width: 62px;
            }
            .chip_vote:hover > span {
                cursor: pointer;
                display: inline-block;
            }
            .downvote:hover,
            .upvote:hover {
                color: #333;
            }
            .chip_name .delta {
                padding-left: 5px;
                font-weight: 700;
            }
            .chip_name .delta:empty {
                display: none;
            }
            .chip_name:hover .delta {
                display: none;
            }
        </style>
        <div class="demo-list-action mdl-list">
            ${this.controls.map(s => s.render()).join('')}
        </div>
        `
        this.init()
    }
}

class ControlBase {
    name: string;
    level: number;
    slug: string;

    topic: string;      // overall topic for this stat (i.e. housing)
    label: string;      // specific label for this stat (i.e. price)
    qualifier: string;  // qualifier for this stat (i.e. median)
    humanFriendlyName: string; // descriptive, human-friendly version of the name
    humanFriendlyDeltaName: string; // descriptive, human-friendly version of the name (delta/change)

    data: BasicStatStructure;
    parent: ?Controls;

    constructor (name: string, data: BasicStatStructure | CategoricalStatStructure | ComplexStatStructure, parent: Controls, level: number) {
        this.name = name
        this.slug = name.replace(':', '_')

        let chunks = name.split(':')
        this.topic = chunks[chunks.length - 2]
        this.label = utils.prettyName(chunks[chunks.length - 1])
        this.qualifier = data.qualifier || ''

        this.data = data
        this.parent = parent
        this.level = level

        this.onHover = this.onHover.bind(this)
        this.onClick = this.onClick.bind(this)
        this.onMouseOut = this.onMouseOut.bind(this)
        this.generateHumanFriendlyName()
    }

    init () {
        let element = document.getElementById(this.slug)
        if (element) {
            element.addEventListener('mouseover', this.onHover)
            element.addEventListener('click', this.onClick)
            element.addEventListener('mouseout', this.onMouseOut)
        }
    }

    generateHumanFriendlyName() {
        let qualifier = this.qualifier ? utils.prettyName(this.qualifier) : ''
        let label = this.label
        if (qualifier === this.label) {
            // both use non-descriptive names like "median", use topic name instead (i.e. business:median -> Median Business)
            label = utils.prettyName(this.topic)
        } else if (this.data.unit === 'score' && !/Score/.test(label)) {
            // instead of using funky score unit, change label to reflect that this is a score
            label += ' Score'
        } else if (['Score', 'Count', 'Units'].includes(label)) {
            // improve to be more descriptive
            label = `${utils.prettyName(this.topic)} ${label}`
        } else if (this.data.unit === '%' && !label.includes('Rate') && !label.includes('Ratio') && !label.includes('Percent')) {
            label = '% ' + label
        }
        if (['taxes'].includes(this.topic)) {
            // we'll omit the qualifier for tax data as it makes it too verbose
            this.humanFriendlyName = label
        } else {
            this.humanFriendlyDeltaName = label + ' Change'
            this.humanFriendlyName = [qualifier, label].join(' ')
        }
    }

    onHover (e?: Event) {
        const originalInstance = document.getElementById(this.slug)
        if (this.data.info) {
            pubsub.publish('tooltip:show', {
                element: e?.currentTarget || originalInstance,
                message: `${this.data.info}.`
            })
        }
        expansions.forEach((expansion, level) => {
            if (level > this.level) {
                expansion.style.display = ''
            } else if (level === this.level && expansion) {
                Array.from(expansion.getElementsByClassName(selectedMetric)).forEach(e => e.classList.remove(selectedMetric))
            }
        })

        // this will be false when hovering over search suggestions, but true for original/main list
        if (!e || e.currentTarget === originalInstance) {
            originalInstance.classList.add(selectedMetric)
            if (this.parentCategory) {
                document.getElementById(this.parentCategory).classList.add(selectedMetric)
            }
        }
    }
    onClick () {}

    onMouseOut () {
        document.getElementById(this.slug).classList.remove(selectedMetric)
    }
}

class BasicControl extends ControlBase {

    parentCategory: ?string;

    constructor(name: string, data: BasicStatStructure, parent: Controls, level: number = 1) {
        super(name, data, parent, level)
        this.slug = this.slug + '_basic'
        this.delta = 0
        this.generateHumanFriendlyName()
    }

    onClick (e: MouseEvent) {
        this.parent._menuOpen = false
        if (!e || !e.shiftKey) {
            expandMenu.style.display = ''
            expandMenu2.style.display = ''
            expandMenu3.style.display = ''
        }
        this.parent.renderChip(null, this.name, this.data.info, false, this.data.negate ? -1 : 1)
        Array.from(document.getElementsByClassName(expandedTag)).forEach(e => e.classList.remove(expandedTag))
    }

    render () {
        return `
        <li id="${this.slug}" class="mdl-list__item selectable_stat level_${this.level}">
            <span class="mdl-list__item-primary-content">
                <i class="material-icons  mdl-list__item-icon">trending_up</i>
                ${this.humanFriendlyName}
            </span>
        </li>
        `
    }
}

class CategoryControl extends ControlBase {

    data: CategoricalStatStructure;
    children: BasicControl[]

    constructor (name: string, data: CategoricalStatStructure, parent: Controls, level: number = 1) {
        super(name, data, parent, level)
        this.slug = this.slug + '_categorical'
        this.data.info += ` (categories: ${this.data.categories.map(c => utils.prettyName(c)).join(', ')})`
        this.children = []
        this.generateHumanFriendlyName()
    }

    setChildren(children: BasicControl[]) {
        this.children = children
        children.forEach(s => {
            s.level = this.level + 1
            s.parentCategory = this.slug
        })
    }

    onHover () {
        super.onHover()

        let element = document.getElementById(this.slug)
        let expansion = expansions[this.level + 1]

        expansion.innerHTML = `
        <div class="demo-list-action mdl-list">
            ${this.children.map(s => s.render()).join('')}
        </div>
        `
        this.children.forEach(s => s.init())

        // display + align menu vertically
        expansion.style.display = 'block'
        expansion.style.top = `${Math.min(element.offsetTop + expandMenu.offsetTop - header.offsetHeight, mapContainer.offsetHeight - expansion.offsetHeight)}px`
    }

    onClick (e: MouseEvent) {
        this.parent._menuOpen = false
        if (!e || !e.shiftKey) {
            expandMenu.style.display = ''
            expandMenu2.style.display = ''
            expandMenu3.style.display = ''
        }
        this.parent.renderChip(null, this.name, this.data.info, true)
        Array.from(document.getElementsByClassName(expandedTag)).forEach(e => e.classList.remove(expandedTag))
    }

    render () {
        return `
        <li id="${this.slug}" class="mdl-list__item selectable_stat level_${this.level}">
            <span class="mdl-list__item-primary-content">
                <i class="material-icons  mdl-list__item-icon">pie_chart</i>
                ${this.humanFriendlyName}
            </span>
            <span class="mdl-list__item-secondary-action">
                <i class="material-icons">chevron_right</i>
            </span>
        </li>
        `
    }
}

class ComplexControl extends ControlBase {

    icon: string;
    level: number
    data: ComplexStatStructure;
    exclude: string[]
    children: (CategoryControl | BasicControl)[]
    categories: CategoryControl[]
    isComplex = true

    constructor (name: string, data: ComplexStatStructure, parent: Controls, icon: string, level: number = 0) {
        super(name, data, parent, level)
        if (this.data.info) {
            this.data.info = `Expand to see ${this.data.info}`
        }
        this.exclude = []
        this.slug = this.slug + '_complex'
        this.icon = icon
        this.categories = []
        this.children = Object.keys(data.children).map(childName => {
            let stat = data.children[childName]
            let fullName = `${name}:${childName}`
            if (stat.type.slice(0, 11) === 'categorical') {
                this.exclude = [...this.exclude, ...stat.categories.map(n => `${name}:${n}`)]
                let control = new CategoryControl(fullName, stat, parent, level + 1)
                this.categories.push(control)
                return control
            } else if (stat.type === 'complex') {
                parent.complexMap[childName] = new ComplexControl(fullName, stat, parent, icons[childName] || icon, level + 1)
                return parent.complexMap[childName]
            } else {
                return new BasicControl(fullName, stat, parent, level + 1)
            }
        })
        this.categories.forEach(c => {
            let children = this.children.filter(s => {
                let nameParts = s.name.split(':')
                return c.data.categories.includes(nameParts[nameParts.length - 1])
            })
            c.setChildren(children)
        })
        this.generateHumanFriendlyName()
    }

    // helper function used by hover and click
    _expandMetrics () {
        Array.from(document.getElementsByClassName(selectedMetric)).forEach(e => e.classList.remove(selectedMetric))
        Array.from(document.getElementsByClassName(expandedTag)).forEach(e => e.classList.remove(expandedTag))
        let element = document.getElementById(this.slug)
        element.classList.add(expandedTag)

        expandMenu.innerHTML = `
        <div class="demo-list-action mdl-list">
            ${this.children.filter(s => !this.exclude.includes(s.name)).map(s => s.render()).join('')}
        </div>
        `
        this.children.forEach(s => s.init())
        expandMenu2.style.display = ''
        expandMenu3.style.display = ''

        // display + align menu vertically
        expandMenu.style.display = 'block'
        expandMenu.style.top = `${Math.min(element.offsetTop - header.offsetHeight, mapContainer.offsetHeight - expandMenu.offsetHeight)}px`
    }

    onHover () {
        super.onHover()
        if (!this.level && this.parent._menuOpen) {
            // used to expand main menu
            this._expandMetrics()
        } else if (this.parent._menuOpen) {
            // used for sub-menus
            let element = document.getElementById(this.slug)
            let expansion = expansions[this.level + 1]

            expansion.innerHTML = `
            <div class="demo-list-action mdl-list">
                ${this.children.filter(s => !this.exclude.includes(s.name)).map(s => s.render()).join('')}
            </div>
            `
            this.children.forEach(s => s.init())

            // display + align menu vertically
            expansion.style.display = 'block'
            expansion.style.top = `${Math.min(element.offsetTop + expandMenu.offsetTop - header.offsetHeight, mapContainer.offsetHeight - expansion.offsetHeight)}px`
        }
    }

    onClick (e) {
        this.parent._menuOpen = !this.parent._menuOpen
        if (this.parent._menuOpen) {
            this._expandMetrics()
        } else {
            expandMenu.style.display = ''
            expandMenu2.style.display = ''
        }
    }

    onMouseOut () {
        if (!this.parent._menuOpen) {
            document.getElementById(this.slug).classList.remove(expandedTag)
        }
    }

    getChildCount() {
        let length = this.children.length
        this.children.forEach(c => {
            if (c.getChildCount) {
                length += c.getChildCount()
            }
        })
        return length
    }

    render () {
        let defaultChild = this.data.children[this.data.defaultChild]

        return `
        <li id='${this.slug}' class="mdl-list__item mdl-list__item--two-line expand_stats level_${this.level}">
            <span class="mdl-list__item-primary-content">
                <i class="material-icons  mdl-list__item-icon">${this.icon || 'view_headline'}</i>
                <span>${this.label}</span>
                <span class="mdl-list__item-sub-title">${this.getChildCount()} metrics</span>
            </span>
            <span class="mdl-list__item-secondary-action">
                <i class="material-icons">chevron_right</i>
            </span>
        </li>
        `
    }
}